import { ReactComponent as Gold } from "assets/icons/gold.svg";
import { ReactComponent as GoldCartOrder } from "assets/icons/goldCartOrder.svg";
import { ReactComponent as PinkRing } from "assets/icons/pinkRing.svg";
import { ReactComponent as GoldBarBreadcrumb } from "assets/icons/goldBarBreadcrumb.svg";
import { ReactComponent as BlueDiamond } from "assets/icons/blueDiamond.svg";
import { ReactComponent as GreenCategory } from "assets/icons/greenCategory.svg";
import { ReactComponent as Bronze } from "assets/icons/brozen.svg";
import { ReactComponent as BronzeCartOrder } from "assets/icons/brozenCartOrder.svg";
import { ReactComponent as Silver } from "assets/icons/sliver.svg";
import { ReactComponent as UnderRatio } from "assets/icons/underRatio.svg";
import { ReactComponent as SilverCartOrder } from "assets/icons/sliverCartOrder.svg";
import { ReactComponent as Diamond } from "assets/icons/diamond.svg";
import { ReactComponent as BlackScaleCartOrder } from "assets/icons/BlackScaleCartOrder.svg";
import { ReactComponent as BlackGoldbarCartOrder } from "assets/icons/BlackGoldbarCartOrder.svg";
import { ReactComponent as ColorGold } from "../assets/icons/goldbar.svg";
import { ReactComponent as BlackDiamondCartOrder } from "assets/icons/BlackDiamondCartOrder.svg";
import { ReactComponent as DiamondCartOrder } from "assets/icons/diamondCartOrder.svg";
import { ReactComponent as BlackDimondIcon } from "assets/icons/Set Tray Icon/Diamond.svg";
import { ReactComponent as Babor } from "assets/icons/babor.svg";
import { ReactComponent as BlackBabor } from "assets/icons/Set Tray Icon/Labor.svg";
import { ReactComponent as DateIcon } from "assets/icons/date.svg";
import { ReactComponent as BlackDateIcon } from "assets/icons/Black_Calender.svg";
import { ReactComponent as Weight } from "assets/icons/small.svg";
import { ReactComponent as WeightCartOrder } from "assets/icons/smallCartOrder.svg";
import { ReactComponent as BlackWeight } from "assets/icons/Set Tray Icon/gold.svg";
import { ReactComponent as CatalogClientReportProductViewEye } from "assets/catalogSetting/ViewProduct/eye.svg";
import { ReactComponent as CatalogClientReportProductCart } from "assets/catalogSetting/ViewProduct/Cart.svg";
import { ReactComponent as CatalogClientReportProductRemoveCart } from "assets/catalogSetting/ViewProduct/RemoveCart.svg";
import { ReactComponent as CatalogClientReportProductClock } from "assets/catalogSetting/ViewProduct/Clock.svg";
import { ReactComponent as OrderClient } from "assets/icons/Client.svg";
import { ReactComponent as SetsIcons } from "assets/sidebar/enable/sets.svg";
import { ReactComponent as SetsIconsCartOrder } from "assets/icons/setsCartOrder.svg";
import { ReactComponent as SetsIconsCartOrderGreen } from "assets/icons/setsCartOrderGreen.svg";
import { ReactComponent as CollectionIcon } from "assets/sidebar/enable/collection.svg";
import { ReactComponent as BalckCollectionIcon } from "assets/icons/Set Tray Icon/collection.svg";
import { ReactComponent as EyeBtn } from "assets/icons/CatalogueCard/eye.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { ReactComponent as GoToTop } from "assets/icons/goTop.svg";
import { ReactComponent as Next } from "assets/icons/next.svg";
import { ReactComponent as Prev } from "assets/icons/prev.svg";
import { ReactComponent as Sales_black } from "assets/sale_icon/sale_Black.svg";
import { ReactComponent as Sales } from "assets/sale_icon/sale.svg";
import { ReactComponent as GoldCup } from "assets/cup_icon/gold-cup.svg";
import { ReactComponent as SilverCup } from "assets/cup_icon/silver-cup.svg";
import { ReactComponent as BronzeCup } from "assets/cup_icon/brown-cup.svg";
import { ReactComponent as TrendUp } from "assets/trend_icon/trend-up.svg";
import { ReactComponent as TrendDown } from "assets/trend_icon/trend-down.svg";
import { ReactComponent as H_labor } from "assets/labor_icon/H.svg";
import { ReactComponent as R_labor } from "assets/labor_icon/R.svg";
import { ReactComponent as X_labor } from "assets/labor_icon/X.svg";
import { ReactComponent as X2_labor } from "assets/labor_icon/X2.svg";
import { ReactComponent as X5_labor } from "assets/labor_icon/X5.svg";
import { ReactComponent as X8_labor } from "assets/labor_icon/X8.svg";
import { ReactComponent as XX_labor } from "assets/labor_icon/XX.svg";
import { ReactComponent as H_labor_black } from "assets/labor_icon/H_Black.svg";
import { ReactComponent as R_labor_black } from "assets/labor_icon/R_Black.svg";
import { ReactComponent as X_labor_black } from "assets/labor_icon/X_Black.svg";
import { ReactComponent as X2_labor_black } from "assets/labor_icon/X2_Black.svg";
import { ReactComponent as X5_labor_black } from "assets/labor_icon/X5_Black.svg";
import { ReactComponent as X8_labor_black } from "assets/labor_icon/X8_Black.svg";
import { ReactComponent as XX_labor_black } from "assets/labor_icon/XX_Black.svg";
import { ReactComponent as CreateModification } from "assets/icons/create_modification.svg";
import { ReactComponent as CreateModificationBlack } from "assets/icons/create_modification_black.svg";
import { ReactComponent as Arrow_Up } from "assets/filter/arrow-up.svg";
import { ReactComponent as Arrow_Down } from "assets/filter/arrow-down.svg";
import { ReactComponent as Public } from "assets/sale_icon/public.svg";
import { ReactComponent as Ring } from "assets/icons/Ring.svg";
import { ReactComponent as GemStone } from "assets/icons/GemStone.svg";
import { ReactComponent as BlackGemStone } from "assets/icons/BlackGemStone.svg";
import { ReactComponent as Scale } from "assets/icons/Scale.svg";
import { ReactComponent as BlackScale } from "assets/icons/BlackScale.svg";
import { ReactComponent as MakeType } from "assets/icons/MakeType.svg";
import { ReactComponent as LightSales } from "assets/icons/LightSales.svg";
import { ReactComponent as LightDate } from "assets/icons/LightDate.svg";
import { ReactComponent as ChartAvg } from "assets/icons/chart-average.svg";
import { ReactComponent as UserGrp } from "assets/icons/users-grp.svg";
import { ReactComponent as CadIcon } from "assets/icons/Cad.svg";
import { ReactComponent as CadIcon_Black } from "assets/icons/Cad_Black.svg";
import { ReactComponent as BBM } from "assets/icons/BBM.svg";
import { ReactComponent as BBS } from "assets/icons/BBS.svg";
import { ReactComponent as HQ } from "assets/icons/HQ.svg";
import { ReactComponent as BBMC } from "assets/icons/bbm_cust.svg";
import { ReactComponent as BBSC } from "assets/icons/bbs_cust.svg";
import { ReactComponent as Memo } from "assets/icons/Memo.svg";
import { ReactComponent as IDL } from "assets/icons/IDL.svg";
import { ReactComponent as InStock } from "assets/icons/InStock.svg";
import { ReactComponent as OutOfStock } from "assets/icons/OutOfStock.svg";
import { ReactComponent as SalesAverage } from "assets/icons/salesAverage.svg";
import { ReactComponent as AutoRestricted } from "assets/icons/autoRestricted.svg";
import { ReactComponent as ManualRestricted } from "assets/icons/manualRestricted.svg";
import { ReactComponent as StockCountIcon } from "assets/icons/StockCount.svg";
import { ReactComponent as CategorySVG } from "../assets/drawer_icon/category.svg";
import { ReactComponent as CategorySVGBlack } from "../assets/drawer_icon/categoryBlack.svg";
import { ReactComponent as CatalogSVG } from "../assets/drawer_icon/catalogIcon.svg";
import { ReactComponent as CatalogSVGBlack } from "../assets/drawer_icon/catalogIconBlack.svg";
import { ReactComponent as CollectionSVG } from "../assets/drawer_icon/collection.svg";
import { ReactComponent as CollectionSVGBlack } from "../assets/drawer_icon/collectionBlack.svg";
import { ReactComponent as SetsDrawerSVG } from "../assets/drawer_icon/setsDrawerIcon.svg";
import { ReactComponent as SetsDrawerSVGBlack } from "../assets/drawer_icon/setsDrawerIconBlack.svg";
import { ReactComponent as StocksDrawerSVG } from "../assets/drawer_icon/StocksDrawerIcon.svg";
import { ReactComponent as StocksDrawerSVGBlack } from "../assets/drawer_icon/StocksDrawerIconBlack.svg";
import { ReactComponent as CrossCreateOrder } from "assets/icons/CrossCreateOrder.svg";
import { ReactComponent as OtherMaterial } from "assets/icons/OtherMaterial.svg";
import { ReactComponent as BlackOtherMaterial } from "assets/icons/BlackOtherMaterial.svg";
import { ReactComponent as BulueDiamond } from "assets/filter/filter header/blue_diamond.svg";
import { ReactComponent as GreenBar } from "assets/filter/filter header/metal-bar-stainless-steel-construction-svgrepo-com 1.svg";
import { ReactComponent as GrayBar } from "assets/filter/filter header/g10236.svg";
import { ReactComponent as SmallDownArrow } from "assets/icons/Arrowdownsmall.svg";
import { ReactComponent as DeleteIcon } from "assets/icons/DeleteIcon.svg";
import { ReactComponent as WhiteDustbinIcon } from "assets/icons/whiteTrash.svg";
import { ReactComponent as DustbinIcon } from "assets/icons/dustbinIcon.svg";
import { ReactComponent as BoxCrossIcon } from "assets/icons/Cross_Box.svg";
import { ReactComponent as GreenEditIcon } from "assets/icons/greenEditIcon.svg";
import { ReactComponent as Cross } from "assets/icons/update_img_icons/cross.svg";
import { ReactComponent as Flag } from "assets/icons/Flag.svg";
import { ReactComponent as PrevIcon } from "assets/icons/PreviousArrowBox.svg";
import { ReactComponent as NextIcon } from "assets/icons/NextArrowBox.svg";
import { ReactComponent as BigBoxCrossIcon } from "assets/icons/BigCrossBox.svg";
import { ReactComponent as UspDetailIcon } from "assets/icons/USPDetailIcon.svg";
import { ReactComponent as SingleUserIcons } from "assets/icons/SingleUssersIcon.svg";
import { ReactComponent as MultipleUserIcons } from "assets/icons/MultipleUsersIcon.svg";
import { ReactComponent as DisselectCartIcon } from "assets/icons/roundCartIcon.svg";
import { ReactComponent as SelectCartIcon } from "assets/icons/selectedCartIcon.svg";
import { ReactComponent as CreateIcon } from "assets/icons/createlogo.svg";
import { ReactComponent as WhiteCreateIcon } from "assets/icons/createlogo_white.svg";
import { ReactComponent as BlueDownloadIcon } from "assets/icons/Blue_DownloadIcon.svg";
import { ReactComponent as BigBlueDownloadIcon } from "assets/icons/BigBlueDownloadIcon.svg";
import { ReactComponent as UserBorder } from "assets/icons/UserClients.svg";
import { ReactComponent as DustbinBorder } from "assets/icons/DustbinBorder.svg";
import { ReactComponent as ReportBorder } from "assets/icons/Reports.svg";
import { ReactComponent as RatioIcon } from "assets/icons/Ratio.svg";
import { ReactComponent as RatioBlackIcon } from "assets/icons/RatioIconBlack.svg";
import { ReactComponent as QuantityIcon } from "assets/icons/QuantityIcon.svg";
import { ReactComponent as BulkActiveIcon } from "assets/icons/BulkActiveIcon.svg";
import { ReactComponent as BulkIcon } from "assets/icons/BulkIcon copy.svg";
import { ReactComponent as VsionProjectIcon } from "assets/projectIcons/Vision.svg";
import { ReactComponent as CreateProjectIcon } from "assets/projectIcons/Create.svg";
import { ReactComponent as SelectProjectIcon } from "assets/projectIcons/Select.svg";
import { ReactComponent as VisionIcon } from "../assets/icons/VisionIcon.svg";
import { ReactComponent as Rodium } from "../assets/icons/rodium.svg";
import { ReactComponent as Priority } from "../assets/icons/priorityOrder.svg";
import { ReactComponent as Certification } from "../assets/icons/Certification.svg";
import { ReactComponent as BookType } from "../assets/icons/BookType.svg";
import { ReactComponent as Purchase } from "../assets/icons/PurchaseOrderNo.svg";
import { ReactComponent as Stamp } from "../assets/icons/StampInstruction.svg";

//Second SideBar
import { ReactComponent as PurchaseActive } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/ActivePurchase.svg";
import { ReactComponent as InActivePurchase } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/InActivePurchase.svg";
import { ReactComponent as ActiveCatalog } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/ActiveCatalog.svg";
import { ReactComponent as InActiveCatalog } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/inActiveCatalog.svg";
import { ReactComponent as ActiveDues } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/ActiveDues.svg";
import { ReactComponent as InActiveDues } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/InActiveDues.svg";
import { ReactComponent as ActiveQuotes } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/ActiveQuotes.svg";
import { ReactComponent as InActiveQuotes } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/InActiveQuotes.svg";
import { ReactComponent as ActiveWIP } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/ActiveWIP.svg";
import { ReactComponent as InActiveWIP } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/InActiveWIP.svg";
import { ReactComponent as ActiveNPD } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/ActiveNPD.svg";
import { ReactComponent as InActiveNPD } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/InActiveNPD.svg";
import { ReactComponent as ActiveServiceRequest } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/ActiveServiceRequest.svg";
import { ReactComponent as InActiveServiceRequest } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/InActiveServiceRequest.svg";
import { ReactComponent as ActiveRequestVisit } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/ActiveRequestVisit.svg";
import { ReactComponent as InActiveRequestVisit } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/InActiveRequestVisit.svg";

import { ReactComponent as PurchaseActive2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/WhitePurchase.svg";
import { ReactComponent as InActivePurchase2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/GrayPurchase.svg";
import { ReactComponent as ActiveCatalog2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/WhiteCatalog.svg";
import { ReactComponent as InActiveCatalog2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/GrayCatalog.svg";
import { ReactComponent as ActiveDues2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/WhiteDues.svg";
import { ReactComponent as InActiveDues2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/GrayDues.svg";
import { ReactComponent as ActiveQuotes2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/WhiteQuotes.svg";
import { ReactComponent as InActiveQuotes2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/GrayQuotes.svg";
import { ReactComponent as ActiveWIP2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/WhiteWIP.svg";
import { ReactComponent as InActiveWIP2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/GrayWIP.svg";
import { ReactComponent as ActiveNPD2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/WhiteNPD.svg";
import { ReactComponent as InActiveNPD2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/GrayNPD.svg";
import { ReactComponent as ActiveServiceRequest2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/WhiteServiceRequest.svg";
import { ReactComponent as InActiveServiceRequest2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/GrayServiceRequest.svg";
import { ReactComponent as ActiveRequestVisit2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/WhiteRequestVisit.svg";
import { ReactComponent as InActiveRequestVisit2X } from "../assets/icons/Clients_Flow_Icons/breadCrumbIcon/GrayRequestVisit.svg";

import { ReactComponent as PartialSets } from "../assets/icons/Clients_Flow_Icons/clientCardIcons/PartialSet_Icon.svg";
import { ReactComponent as Dues } from "../assets/icons/Clients_Flow_Icons/clientCardIcons/due_icon.svg";
import { ReactComponent as Ledger } from "../assets/icons/Clients_Flow_Icons/clientCardIcons/ledger_icon.svg";
import { ReactComponent as Green_Wallet } from "../assets/icons/Clients_Flow_Icons/clientCardIcons/green_wallet_icon.svg";
import { ReactComponent as Grey_Wallet } from "../assets/icons/Clients_Flow_Icons/clientCardIcons/grey_wallet_icon.svg";
import { ReactComponent as RedBag } from "../assets/icons/Clients_Flow_Icons/clientCardIcons/red_bag_icon.svg";
import { ReactComponent as GoldBar } from "../assets/icons/Clients_Flow_Icons/clientCardIcons/small_goldbar_icon.svg";
import { ReactComponent as Small_Diamond } from "../assets/icons/Clients_Flow_Icons/clientCardIcons/small_diamond_icon.svg";
import { ReactComponent as Blue_Bill } from "../assets/icons/Clients_Flow_Icons/clientInnerCardIcons/blue_bill_Icon.svg";
import { ReactComponent as Due_Date } from "../assets/icons/Clients_Flow_Icons/clientInnerCardIcons/due_date_Icon.svg";
import { ReactComponent as Due_Date_Days } from "../assets/icons/Clients_Flow_Icons/clientInnerCardIcons/due_date_days_Icon.svg";
import { ReactComponent as Grey_Date_Icon } from "../assets/icons/Clients_Flow_Icons/clientInnerCardIcons/Grey_Date_Icon.svg";
import { ReactComponent as Total_Ledger_Icon } from "../assets/icons/Clients_Flow_Icons/TotalLedgerIcon.svg";
import { ReactComponent as Received_Icon } from "../assets/icons/Clients_Flow_Icons/ReceivedIcon.svg";
import { ReactComponent as White_Wallet_Icon } from "../assets/icons/Clients_Flow_Icons/White_Wallet_Icon.svg";
import { ReactComponent as Grey_Wallet_Icon } from "../assets/icons/Clients_Flow_Icons/Grey_Wallet_Icon.svg";
import { ReactComponent as Black_User_Icon } from "../assets/icons/Clients_Flow_Icons/Black_User_Icon.svg";
import { ReactComponent as Black_Clock_Icon } from "../assets/icons/Clients_Flow_Icons/Black_Clock_Icon.svg";
import { ReactComponent as White_Bag_Icon } from "../assets/icons/Clients_Flow_Icons/PurchaseCardIcons/white_Bag_Icon.svg";
import { ReactComponent as Green_Date_Icon } from "../assets/icons/Clients_Flow_Icons/PurchaseCardIcons/Green_Date_Icon.svg";
import { ReactComponent as White_Message_Icon } from "../assets/icons/Clients_Flow_Icons/PurchaseCardIcons/white_Message_Icon.svg";
import { ReactComponent as White_Location_Icon } from "../assets/icons/Clients_Flow_Icons/PurchaseCardIcons/white_Location_Icon.svg";
import { ReactComponent as White_OrderNote_Icon } from "../assets/icons/Clients_Flow_Icons/PurchaseCardIcons/white_OrderNote_Icon.svg";
import { ReactComponent as White_Department_Icon } from "../assets/icons/Clients_Flow_Icons/PurchaseCardIcons/department_Icon.svg";
import { ReactComponent as Grey_Material_Icon } from "../assets/icons/Clients_Flow_Icons/modalIcon/Greay_Material_Icon.svg";
import { ReactComponent as Grey_Certificate_Icon } from "../assets/icons/Clients_Flow_Icons/modalIcon/Grey_Certificate_Icon.svg";
import { ReactComponent as Black_OrderNote_Icon } from "../assets/icons/Clients_Flow_Icons/modalIcon/Black_OrderNote_Icon.svg";
import { ReactComponent as Due_Date_Days_White } from "../assets/icons/Clients_Flow_Icons/clientInnerCardIcons/due_date_days_white.svg";
import { ReactComponent as Double_Arrow } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/doubleArrow.svg";
import { ReactComponent as Double_Arrow_Right } from "../assets/icons/Clients_Flow_Icons/sideBarIcons/doubleArraowRight.svg";
import { ReactComponent as Red_Wallet } from "../assets/icons/Clients_Flow_Icons/clientCardIcons/red_wallet_icon.svg";
import { ReactComponent as ReviewIcon } from "../assets/icons/Service Request Flow/ReviewIcon.svg";
import { ReactComponent as AcceptedIcon } from "../assets/icons/Service Request Flow/AcceptedIcon.svg";
import { ReactComponent as ReceivedNewIcon } from "../assets/icons/Service Request Flow/ReceivedIcon.svg";
import { ReactComponent as ProductionIcon } from "../assets/icons/Service Request Flow/ProductionIcon.svg";
import { ReactComponent as NeedYourApprovalIcon } from "../assets/icons/Service Request Flow/NeedYourApprovalIcon.svg";
import { ReactComponent as ReadyForDispatchIcon } from "../assets/icons/Service Request Flow/ReadyForDispatchIcon.svg";
import { ReactComponent as DispatchedIcon } from "../assets/icons/Service Request Flow/DispatchedIcon.svg";
import { ReactComponent as RepairingRequestIcon } from "../assets/icons/Service Request Flow/RepairingRequestIcon.svg";
import { ReactComponent as QcFailedIcon } from "../assets/icons/Service Request Flow/QCFailedIcon.svg";
import { ReactComponent as ManufacturingDefectsIcon } from "../assets/icons/Service Request Flow/ManufacturingDefectsIcon.svg";

import { ReactComponent as GreenAcceptedIcon } from "../assets/icons/Service Request Flow/GreenAcceptedIcon.svg";
import { ReactComponent as GreyAcceptedIcon } from "../assets/icons/Service Request Flow/GreyAcceptedIcon.svg";
import { ReactComponent as GreenReceivedIcon } from "../assets/icons/Service Request Flow/GreenReceivedIcon.svg";
import { ReactComponent as GreyReceivedIcon } from "../assets/icons/Service Request Flow/GreyReceivedIcon.svg";
import { ReactComponent as GreenProductionIcon } from "../assets/icons/Service Request Flow/GreenProductionIcon.svg";
import { ReactComponent as GreyProductionIcon } from "../assets/icons/Service Request Flow/GreyProductionIcon.svg";
import { ReactComponent as GreenNeedYourApprovalIcon } from "../assets/icons/Service Request Flow/GreenNeedYourApprovalIcon.svg";
import { ReactComponent as GreyNeedYourApprovalIcon } from "../assets/icons/Service Request Flow/GreyNeedYourApprovalIcon.svg";
import { ReactComponent as GreenReadyForDispatchIcon } from "../assets/icons/Service Request Flow/GreenReadyForDispatchIcon.svg";
import { ReactComponent as GreyReadyForDispatchIcon } from "../assets/icons/Service Request Flow/GreyReadyForDispatchIcon.svg";
import { ReactComponent as GreenDispatchedIcon } from "../assets/icons/Service Request Flow/GreenDispatchedIcon.svg";
import { ReactComponent as GreyDispatchedIcon } from "../assets/icons/Service Request Flow/GreyDispatchedIcon.svg";
import { ReactComponent as BlackMicIcon } from "../assets/icons/Service Request Flow/BlackMicIcon.svg";
import { ReactComponent as BlackPlayIcon } from "../assets/icons/Service Request Flow/BlackPlayIcon.svg";
import { ReactComponent as WhiteVolumnIcon } from "../assets/icons/Service Request Flow/WhiteVolumnIcon.svg";
import { ReactComponent as BlueRingIcon } from "../assets/icons/Service Request Flow/BlueRngIcon.svg";
import { ReactComponent as GreenCategoryIcon } from "../assets/icons/Service Request Flow/GreenCategoryIcon.svg";
import { ReactComponent as BluePhoneIcon } from "../assets/icons/Service Request Flow/BluePhoneIcon.svg";
import { ReactComponent as YellowPinCodeIcon } from "../assets/icons/Service Request Flow/YellowPinCodeIcon.svg";

import { ReactComponent as ReceivedPurpleIcon } from "../assets/icons/Service Request Flow/ReceivedPurpleIcon.svg";
import { ReactComponent as CancelledReceiveIcon } from "../assets/icons/Service Request Flow/CancelledReceivedIcon.svg";
import { ReactComponent as PinkRepairIcon } from "../assets/icons/Service Request Flow/PinkRepairIcon.svg";
import { ReactComponent as YellowDateIcon } from "../assets/icons/Service Request Flow/YellowDateIcon.svg";
import { ReactComponent as GreyEditIcon } from "../assets/icons/Service Request Flow/GreyEditIcon.svg";
import { ReactComponent as WaitingRoomIcon } from "../assets/icons/Service Request Flow/WaitingRoomIcon.svg";
import { ReactComponent as UploadIcon } from "../assets/icons/Service Request Flow/UploadIcon.svg";
import { ReactComponent as WhiteUploadIcon } from "../assets/icons/Service Request Flow/WhiteUploadIcon.svg";
import { ReactComponent as UploadDesign } from "assets/icons/UploadDesign.svg";
import { ReactComponent as SoldIcon } from "../assets/icons/SoldIcon.svg";

import { ReactComponent as BlackRing } from "assets/icons/BlackRing.svg";
import { ReactComponent as HourGlass } from "assets/icons/HourGlass.svg";
import { ReactComponent as ReorderIcon } from "assets/productIcon/reorder.svg";


import { ReactComponent as CardViewActiveIcon } from "assets/icons/catalogViewIcons/cardViewActiveIcon.svg";
import { ReactComponent as CardViewIcon } from "assets/icons/catalogViewIcons/cardViewIcon.svg";
import { ReactComponent as CategoryActiveIcon } from "assets/icons/catalogViewIcons/categoryActiveIcon.svg";
import { ReactComponent as CategoryIcon } from "assets/icons/catalogViewIcons/categoryIcon.svg";
import { ReactComponent as SetActiveIcon } from "assets/icons/catalogViewIcons/setActiveIcon.svg";
import { ReactComponent as SetIcon } from "assets/icons/catalogViewIcons/setIcon.svg";

// PartialSets;
import { ReactComponent as CrossIcon } from "assets/icons/Cross_Icon.svg";
import { ReactComponent as User_Delete_Icon } from "assets/icons/users/delete_user_icon.svg";
import { ReactComponent as User_Edit_Icon } from "assets/icons/users/edit_user_icon.svg";
import { ReactComponent as User_Modify_Info_Icon } from "assets/icons/users/info_user.svg";
import { ReactComponent as HideIcon } from "assets/icons/HideIcon.svg";
import { ReactComponent as HideBlackIcon } from "assets/icons/HideBlackIcon.svg";
import { ReactComponent as Increase } from "assets/icons/IncreaseIcon.svg";
import { ReactComponent as Decrease } from "assets/icons/DecreaseIcon.svg";

export const getIcon = (type, variant = "default") => {
  const icons = {
    gold: variant === "black" ? <Gold /> : <Gold />,
    UploadDesign: <UploadDesign />,
    HikeArrow : variant === "Red" ? <Decrease/> : <Increase/>,
    Hide: variant === "black" ?  <HideBlackIcon/>: <HideIcon/> ,
    goldCartOrder: variant === "black" ? <BlackGoldbarCartOrder /> : <GoldCartOrder />,
    silver: variant === "black" ? <Silver /> : <Silver />,
    bronze: variant === "black" ? <Bronze /> : <Bronze />,
    "under ratio": variant === "black" ? <UnderRatio /> : <UnderRatio />,
    silverCartOrder: variant === "black" ? <SilverCartOrder /> : <SilverCartOrder />,
    bronzeCartOrder: variant === "black" ? <BronzeCartOrder /> : <BronzeCartOrder />,
    blackScaleCartOrder: variant === "black" ? <BlackScaleCartOrder /> : <BlackScaleCartOrder />,
    diamond: variant === "black" ? <BlackDimondIcon /> : <Diamond />,
    diamondCartOrder: variant === "black" ? <BlackDiamondCartOrder /> : <DiamondCartOrder />,
    goldbar: variant === "black" ? <BlackWeight /> : <Weight />,
    goldbarCartOrder: variant === "black" ? <WeightCartOrder /> : <WeightCartOrder />,
    labour: variant === "black" ? <BlackBabor /> : <Babor />,
    date: variant === "black" ? <BlackDateIcon /> : <DateIcon />,
    catalogView: variant === "black" ? <CatalogClientReportProductViewEye /> : <CatalogClientReportProductViewEye />,
    catalogCart: variant === "black" ? <CatalogClientReportProductCart /> : <CatalogClientReportProductCart />,
    catalogRemoveCart: variant === "black" ? <CatalogClientReportProductRemoveCart /> : <CatalogClientReportProductRemoveCart />,
    catalogClock: variant === "black" ? <CatalogClientReportProductClock /> : <CatalogClientReportProductClock />,
    set: variant === "black" ? <SetsIcons /> : <SetsIcons />,
    Vision_Project_Icon: variant === "black" ? <VisionIcon /> : <VsionProjectIcon />,
    RhoidumIcon: <Rodium />,
    PriorityOrderIcon: <Priority />,
    Certificationicon: <Certification />,
    BookTypeIcon: <BookType />,
    PruchaseOrderIcon: <Purchase />,
    StampInstructionicon: <Stamp />,
    OrderClient: <OrderClient />,
    ColorGold: <ColorGold />,
    CreateModify: variant === "black" ? <CreateModificationBlack /> : <CreateModification />,
    sold: variant === "red" ? <SoldIcon /> : <SoldIcon />,
    setCartOrder: variant === "black" ? <SetsIconsCartOrder /> : <SetsIconsCartOrderGreen />,
    collection: variant === "black" ? <BalckCollectionIcon /> : <CollectionIcon />,
    close: variant === "black" ? <CloseIcon /> : <CloseIcon />,
    eye: variant === "black" ? <EyeBtn /> : <EyeBtn />,
    GoToTop: variant === "black" ? <GoToTop /> : <GoToTop />,
    next: variant === "black" ? <Next /> : <Next />,
    prev: variant === "black" ? <Prev /> : <Prev />,
    trendUp: variant === "black" ? <TrendUp /> : <TrendUp />,
    trendDown: variant === "black" ? <TrendDown /> : <TrendDown />,
    // h_labor: variant === "black" ? <H_labor_black /> : <H_labor />,
    r_labor: variant === "black" ? <R_labor_black /> : <R_labor />,
    x_labor: variant === "black" ? <X_labor_black /> : <X_labor />,
    x2_labor: variant === "black" ? <X2_labor_black /> : <X2_labor />,
    x5_labor: variant === "black" ? <X5_labor_black /> : <X5_labor />,
    x8_labor: variant === "black" ? <X8_labor_black /> : <X8_labor />,
    xx_labor: variant === "black" ? <XX_labor_black /> : <XX_labor />,
    sales: variant === "black" ? <Sales_black /> : <Sales />,
    gold_cup: variant === "black" ? <GoldCup /> : <GoldCup />,
    silver_cup: variant === "black" ? <SilverCup /> : <SilverCup />,
    bronze_cup: variant === "black" ? <BronzeCup /> : <BronzeCup />,
    arrow_up: variant === "black" ? <Arrow_Up /> : <Arrow_Up />,
    arrow_down: variant === "black" ? <Arrow_Down /> : <Arrow_Down />,
    public: variant === "black" ? <Public /> : <Public />,
    ring: variant === "black" ? <Ring /> : <Ring />,
    gemstone: variant === "black" ? <BlackGemStone /> : <GemStone />,
    scale: variant === "black" ? <BlackScale /> : <Scale />,
    in_stock: variant === "black" ? <InStock /> : <InStock />,
    maketype: variant === "black" ? <MakeType /> : <MakeType />,
    lightsales: variant === "black" ? <LightSales /> : <LightSales />,
    lightdate: variant === "black" ? <LightDate /> : <LightDate />,
    chart: variant === "black" ? <ChartAvg /> : <ChartAvg />,
    // H: variant === "black" ? <H_labor_black /> : <H_labor />,
    R: variant === "black" ? <R_labor_black /> : <R_labor />,
    X: variant === "black" ? <X_labor_black /> : <X_labor />,
    X2: variant === "black" ? <X2_labor_black /> : <X2_labor />,
    X5: variant === "black" ? <X5_labor_black /> : <X5_labor />,
    X8: variant === "black" ? <X8_labor_black /> : <X8_labor />,
    XX: variant === "black" ? <XX_labor_black /> : <XX_labor />,
    usergrp: variant === "black" ? <UserGrp /> : <UserGrp />,
    cadIcon: variant === "black" ? <CadIcon_Black /> : <CadIcon />,
    bbm: variant === "black" ? <BBM /> : <BBM />,
    idl: variant === "black" ? <IDL /> : <IDL />,
    bbs: variant === "black" ? <BBS /> : <BBS />,
    hq: variant === "black" ? <HQ /> : <HQ />,
    bbmC: variant === "black" ? <BBMC /> : <BBMC />,
    bbsC: variant === "black" ? <BBSC /> : <BBSC />,
    idl: variant === "black" ? <IDL /> : <IDL />,
    in_stock: variant === "black" ? <InStock /> : <InStock />,
    out_stock: variant === "black" ? <OutOfStock /> : <OutOfStock />,
    sales_average: variant === "black" ? <SalesAverage /> : <SalesAverage />,
    autorestricted: variant === "black" ? <AutoRestricted /> : <AutoRestricted />,
    manualrestricted: variant === "black" ? <ManualRestricted /> : <ManualRestricted />,
    stockCount: variant === "black" ? <StockCountIcon /> : <StockCountIcon />,
    GoldBarBreadcrumb: variant === "black" ? <GoldBarBreadcrumb /> : <GoldBarBreadcrumb />,
    PinkRing: variant === "black" ? <PinkRing /> : <PinkRing />,
    BlueDiamond: variant === "black" ? <BlueDiamond /> : <BlueDiamond />,
    GreenCategory: variant === "black" ? <GreenCategory /> : <GreenCategory />,
    DownArrow: variant === "black" ? <SmallDownArrow /> : <SmallDownArrow />,
    CrossCreateOrder: variant === "black" ? <CrossCreateOrder /> : <CrossCreateOrder />,
    "By Category": variant === "black" ? <CategorySVGBlack /> : <CategorySVG />,
    "By Catalog": variant === "black" ? <CatalogSVGBlack /> : <CatalogSVG />,
    "By Collection": variant === "black" ? <CollectionSVGBlack /> : <CollectionSVG />,
    "By Sets": variant === "black" ? <SetsDrawerSVGBlack /> : <SetsDrawerSVG />,
    "Bulk Quote": variant === "black" ? <BulkIcon /> : <BulkActiveIcon />,
    "By Stock": variant === "black" ? <StocksDrawerSVGBlack /> : <StocksDrawerSVG />,
    "By PartialSets": <PartialSets height={25} width={25} />,
    otherMaterial: variant === "black" ? <BlackOtherMaterial /> : <OtherMaterial />,
    "Diamond Quality": <BulueDiamond />,
    "Gold Purity": <GreenBar />,
    "Gold Color": <GrayBar />,
    Memo: <Memo />,
    DeleteIcon: variant === "black" ? <DeleteIcon /> : <DeleteIcon />,
    DustbinIcon: variant === "white" ? <WhiteDustbinIcon /> : <DustbinIcon />,
    BoxCrossIcon: variant === "black" ? <BoxCrossIcon /> : <BoxCrossIcon />,
    greenEditIcon: variant === "black" ? <GreenEditIcon /> : <GreenEditIcon />,
    Cross: <Cross />,
    Flag: <Flag />,
    PrevIcon: variant === "black" ? <PrevIcon /> : <PrevIcon />,
    NextIcon: variant === "black" ? <NextIcon /> : <NextIcon />,
    BigBoxCrossIcon: variant === "black" ? <BigBoxCrossIcon /> : <BigBoxCrossIcon />,
    UspDetailIcon: variant === "black" ? <UspDetailIcon /> : <UspDetailIcon />,
    singleUserIcon: variant === "black" ? <SingleUserIcons /> : <SingleUserIcons />,
    multipleUserIcon: variant === "black" ? <MultipleUserIcons /> : <MultipleUserIcons />,
    disselectCartIcon: variant === "black" ? <DisselectCartIcon /> : <DisselectCartIcon />,
    selectCartIcon: variant === "black" ? <SelectCartIcon /> : <SelectCartIcon />,
    CreateIcon: variant === "black" ? <CreateIcon /> : <WhiteCreateIcon />,
    UserBorderIcon: <UserBorder />,
    DustbinBorderIcon: <DustbinBorder />,
    ReportBorderIcon: <ReportBorder />,
    RatioIcon: variant === "black" || variant === "default" || !variant ?  <RatioIcon />: <RatioBlackIcon /> ,
    QuantityIcon: <QuantityIcon />,
    DownloadIcon: variant === "black" ? <BlueDownloadIcon /> : <BlueDownloadIcon />,
    BigDownloadIcon: <BigBlueDownloadIcon style={{ height: "2vw", width: "2vw" }} />,

    Purchases: variant === "Active" ? <PurchaseActive /> : <InActivePurchase />,
    Catalog: variant === "Active" ? <ActiveCatalog /> : <InActiveCatalog />,
    "Dues & Ledger": variant === "Active" ? <ActiveDues /> : <InActiveDues />,
    "Quotes & Orders": variant === "Active" ? <ActiveQuotes /> : <InActiveQuotes />,
    WIP: variant === "Active" ? <ActiveWIP /> : <InActiveWIP />,
    "NPD Orders": variant === "Active" ? <ActiveNPD /> : <InActiveNPD />,
    "Service Request": variant === "Active" ? <ActiveServiceRequest /> : <InActiveServiceRequest />,
    "Request Visit": variant === "Active" ? <ActiveRequestVisit /> : <InActiveRequestVisit />,

    Purchases2X: variant === "Active" ? <PurchaseActive2X /> : <InActivePurchase2X />,
    Catalog2X: variant === "Active" ? <ActiveCatalog2X /> : <InActiveCatalog2X />,
    "Dues & Ledger2X": variant === "Active" ? <ActiveDues2X /> : <InActiveDues2X />,
    "Quotes & Orders2X": variant === "Active" ? <ActiveQuotes2X /> : <InActiveQuotes2X />,
    WIP2X: variant === "Active" ? <ActiveWIP2X /> : <InActiveWIP2X />,
    "NPD Orders2X": variant === "Active" ? <ActiveNPD2X /> : <InActiveNPD2X />,
    "Service Request2X": variant === "Active" ? <ActiveServiceRequest2X /> : <InActiveServiceRequest2X />,
    "Request Visit2X": variant === "Active" ? <ActiveRequestVisit2X /> : <InActiveRequestVisit2X />,

    Dues: <Dues />,
    Ledger: <Ledger />,
    Green_Wallet: <Green_Wallet />,
    Red_Wallet: <Red_Wallet />,
    Grey_Wallet: <Grey_Wallet />,
    RedBag: variant === "white" ? <White_Bag_Icon /> : <RedBag />,
    GoldBar: <GoldBar />,
    Small_Diamond: <Small_Diamond />,

    Create_Project_Icon: <CreateProjectIcon />,
    Select_Project_Icon: <SelectProjectIcon />,

    Blue_Bill_Icon: <Blue_Bill />,
    Due_Date_Icon: <Due_Date />,
    Due_Date_Days_Icon: <Due_Date_Days />,
    Due_Date_Days_White: <Due_Date_Days_White />,

    Grey_Date_Icon: <Grey_Date_Icon />,
    Green_Date_Icon: <Green_Date_Icon />,

    Total_Ledger_Icon: <Total_Ledger_Icon />,

    Received_Icon: <Received_Icon />,

    Wallet_Icon: variant === "black" ? <Grey_Wallet_Icon /> : <White_Wallet_Icon />,

    Black_User_Icon: <Black_User_Icon />,
    Black_Clock_Icon: <Black_Clock_Icon />,

    Message_Icon: variant === "white" ? <White_Message_Icon /> : <White_Message_Icon />,

    Location_Icon: variant === "white" ? <White_Location_Icon /> : <White_Location_Icon />,

    OrderNote_Icon: variant === "white" ? <White_OrderNote_Icon /> : <Black_OrderNote_Icon />,

    Department_Icon: variant === "white" ? <White_Department_Icon /> : <White_Department_Icon />,

    Material_Icon: variant === "grey" ? <Grey_Material_Icon /> : <Grey_Material_Icon />,

    Certificate_Icon: variant === "grey" ? <Grey_Certificate_Icon /> : <Grey_Certificate_Icon />,

    Double_Arrow: variant === "back" ? <Double_Arrow /> : <Double_Arrow_Right />,

    // Service Flow Icon
    ReviewIcon: <ReviewIcon />,
    AcceptedIcon: variant === "green" ? <GreenAcceptedIcon /> : variant === "grey" ? <GreyAcceptedIcon /> : <AcceptedIcon />,
    ReceivedNewIcon: variant === "green" ? <GreenReceivedIcon /> : variant === "grey" ? <GreyReceivedIcon /> : <ReceivedNewIcon />,
    ProductionIcon: variant === "green" ? <GreenProductionIcon /> : variant === "grey" ? <GreyProductionIcon /> : <ProductionIcon />,
    NeedYourApprovalIcon: variant === "green" ? <GreenNeedYourApprovalIcon /> : variant === "grey" ? <GreyNeedYourApprovalIcon /> : <NeedYourApprovalIcon />,
    ReadyForDispatchIcon: variant === "green" ? <GreenReadyForDispatchIcon /> : variant === "grey" ? <GreyReadyForDispatchIcon /> : <ReadyForDispatchIcon />,
    DispatchedIcon: variant === "green" ? <GreenDispatchedIcon /> : variant === "grey" ? <GreyDispatchedIcon /> : <DispatchedIcon />,
    RepairingRequestIcon: <RepairingRequestIcon />,
    QcFailedIcon: <QcFailedIcon />,
    ManufacturingDefectsIcon: <ManufacturingDefectsIcon />,
    MicIcon: <BlackMicIcon />,
    PlayIcon: <BlackPlayIcon />,
    VolumnIcon: <WhiteVolumnIcon />,
    BlueRingIcon: <BlueRingIcon />,
    GreenCategoryIcon: <GreenCategoryIcon />,
    CancelledReceiveIcon: <CancelledReceiveIcon />,
    PurpleReceivedNewIcon: <ReceivedPurpleIcon />,
    BluePhoneIcon: <BluePhoneIcon />,
    YellowPinCodeIcon: <YellowPinCodeIcon />,
    PinkRepairIcon: <PinkRepairIcon />,
    YellowDateIcon: <YellowDateIcon />,
    EditIcon: variant === "grey" ? <GreyEditIcon /> : <GreyEditIcon />,
    WaitingRoomIcon: <WaitingRoomIcon />,
    UploadIcon: variant === "white" ? <WhiteUploadIcon /> : <UploadIcon />,
    BlackRing: variant === "black" ? <BlackRing /> : <BlackRing />,
    HourGlass: variant === "black" ? <HourGlass /> : <HourGlass />,

    reorderIcon: variant === "black" ? <ReorderIcon /> : <ReorderIcon />,

    mixView: variant === "active" ? <CardViewActiveIcon /> : <CardViewIcon />,
    CategoryView: variant === "active" ? <CategoryActiveIcon /> : <CategoryIcon />,
    setView: variant === "active" ? <SetActiveIcon /> : <SetIcon />,
    CrossIcon: <CrossIcon />,

    User_Delete_Icon: <User_Delete_Icon />,
    User_Edit_Icon: <User_Edit_Icon />,
    User_Modify_Info_Icon: <User_Modify_Info_Icon />,
  };

  return icons[type] || null;
};
